import React, { Component } from 'react';
import { ValidationType } from '../../Constants/ValidationTypes';
import { Fstyr } from './Fstyr.js';

type Props = {
    show: boolean
    onAccept: (value: string) => void;
};

type State = {
    showSpinner: boolean
    value: string
    repeatedValue: string
    WRXInput1IsValid: boolean
    WRXInput2IsValid: boolean
    saveButtonPressed: boolean
};

export class FstyrBetjentModal extends Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showSpinner: false,
            value: "",
            repeatedValue: "",
            WRXInput1IsValid: false,
            WRXInput2IsValid: false,
            saveButtonPressed: false,
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.show && !this.props.show) this.setState({ showSpinner: false })
    }

    saveButtonClicked() {
        this.setState({ showSpinner: true, saveButtonPressed: true }, () => {
            if (this.state.WRXInput1IsValid && this.state.WRXInput2IsValid ) {
                this.props.onAccept(this.state.value)
            }
        })

    }
    declinedButtonClicked() {
        window.location.replace("https://" + window.location.host)

    }

    render() {
        return (
            this.props.show &&
            <div className="fstyr-modal-background">
                <div className="fstyr-modal-container">
                    <Fstyr.Segment
                        title={"Knyt dit ID-nummer til dit NemLogin"}
                        isPageTitle={true}
                    />
                    <Fstyr.Segment
                        title={"For at oprette dit kontrolkort skal dit ID-nummer gemmes i systemet. Det gøres ved at indtaste dit ID-nummer her, så det knyttes til dit NemLogin."}
                        isPageTitle={true}
                    >
                        <Fstyr.Input
                            value={this.state.value}
                            direction='row'
                            label="ID-nummer"
                            onChange={(value: string) => this.setState({ value: value })}
                            validation={true}
                            validationType={ValidationType.wrxNr}
                            setValid={(valid: boolean) => this.setState({ WRXInput1IsValid: valid })}
                            onValidatingButtonPressed={() => this.setState({ saveButtonPressed: true })}
                            errorBodyText={"Dette felt skal indeholde et ID-nummer, ikke et WRX-nummer (maks. 10 cifre langt)"}
                            errorExampleText={"f.eks. 12345abcde"}
                            buttonClicked={this.state.saveButtonPressed}
                            onEnterPressed={() => this.saveButtonClicked()}
                        />
                        <Fstyr.Input
                            value={this.state.repeatedValue}
                            direction='row'
                            label="Gentag ID-nummer"
                            onChange={(value: string) => this.setState({ repeatedValue: value })}
                            validation={true}
                            validationType={ValidationType.regex}
                            regex={RegExp(`^${this.state.value}$`)}
                            setValid={(valid: boolean) => this.setState({ WRXInput2IsValid: valid })}
                            onValidatingButtonPressed={() => this.setState({ saveButtonPressed: true })}
                            errorBodyText={"De to felter skal være identiske."}
                            buttonClicked={this.state.saveButtonPressed}
                            onEnterPressed={() => this.saveButtonClicked()}
                        />

                    </Fstyr.Segment>

                    <Fstyr.Segment
                        isPageTitle={true}
                    >
                        <div className="fstyr-left-button-group">
                            <Fstyr.Button
                                label={"Gem"}
                                type={"primary"}
                                onClick={() => this.saveButtonClicked()}
                                disabled={this.state.showSpinner || !(this.state.WRXInput1IsValid && this.state.WRXInput2IsValid )}
                            />
                            <Fstyr.Button
                                label={"Annullér"}
                                type={"secondary"}
                                onClick={() => { this.declinedButtonClicked() }}
                            />
                            <Fstyr.Spinner
                                show={this.state.showSpinner}
                            />
                        </div>
                    </Fstyr.Segment>
                </div>
            </div>
        );
    }
}
